import { useRef } from 'react';
// import { useAnimatedPathDrawing } from './helper';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
// import { selectFirstLoading } from 'store/slices/UI-Slice';
// import { useSelector } from 'react-redux';
import useMediaQuery from 'hooks/useMediaQuery';

const NetworkIllustration = ({ isLoading }) => {
    // const loading = useSelector(selectFirstLoading)

    const roundRef = useRef(null);
    const roundLinesRef = useRef(null);
    const speedRef = useRef(null);
    const ellipse1Ref = useRef(null);
    const ellipse2Ref = useRef(null);
    const ellipse3Ref = useRef(null);
    const loaderRef = useRef(null);
    const bgItem1 = useRef(null);
    const bgItem2 = useRef(null);
    const bgItem3 = useRef(null);
    const maxMediaForMask = useMediaQuery('max-width: 1440px');
    const minMediaForMask = useMediaQuery('max-width: 1330px');

    useGSAP(() => {
        if (!isLoading) {
            const tl = gsap.timeline({ repeat: -1 });
            const ellipseTimeline = gsap.timeline({ repeat: -1 });
            const scaleTimeline = gsap.timeline();

            tl.to(roundLinesRef.current, {
                duration: 2,
                strokeWidth: 60,
                ease: 'power1.inOut',
                repeat: -1,
                yoyo: true,
            });

            gsap.to(roundRef.current, {
                rotation: 360,
                transformOrigin: '50% 50%',
                duration: 50,
                repeat: -1,
                ease: 'none',
            });
            gsap.to(speedRef.current, {
                duration: 7,
                roundProps: 'textContent',
                textContent: 100,
                ease: 'elastic.out(0.9,0.7)',
                delay: 0.5,
            });

            ellipseTimeline.to([ellipse1Ref.current, ellipse2Ref.current, ellipse3Ref.current], {
                duration: 5,
                strokeDashoffset: -200,
                ease: 'none',
            });
            gsap.to(loaderRef.current, {
                rotation: 360,
                transformOrigin: 'center',
                duration: 5,
                repeat: -1,
                ease: 'linear',
            });
            gsap.fromTo(
                loaderRef.current,
                {
                    opacity: 0,
                },
                {
                    opacity: 1,
                    duration: 15,
                },
            );

            scaleTimeline
                .set(bgItem1.current, {
                    scale: 0,
                })
                .set(bgItem2.current, {
                    scale: 0,
                })
                .set(bgItem3.current, {
                    scale: 0,
                })
                .to(bgItem1.current, {
                    duration: 1,
                    scale: 1,
                    ease: 'power1.inOut',
                })
                .to(bgItem2.current, {
                    duration: 1,
                    scale: 1,
                    ease: 'power1.inOut',
                })
                .to(bgItem3.current, {
                    duration: 1,
                    scale: 1,
                    ease: 'power1.inOut',
                });
        }
    }, [isLoading]);

    return (
        <svg width="680" height="640" viewBox="0 0 680 640" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_3446_53608)">
                <mask
                    id="mask0_3446_53608"
                    style={{ maskType: 'alpha' }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="680"
                    height="640"
                >
                    {maxMediaForMask === true && minMediaForMask === false ? (
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M96 0H642H664H680V16V544V560H664H642H416C407.163 560 400 567.163 400 576V624C400 632.837 392.837 640 384 640H16C7.16345 640 0 632.837 0 624V296C0 287.163 7.16344 280 16 280H64C72.8366 280 80 272.837 80 264V16C80 7.16344 87.1634 0 96 0Z"
                            fill="#F2F3F8"
                        />
                    ) : (
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M680 16C680 7.16344 672.837 0 664 0H96C87.1634 0 80 7.16344 80 16V264C80 272.837 72.8366 280 64 280H16C7.16344 280 0 287.163 0 296V624C0 632.837 7.16345 640 16 640H384C392.837 640 400 632.837 400 624V576C400 567.163 407.163 560 416 560H664C672.837 560 680 552.837 680 544V16Z"
                            fill="#D9D9D9"
                        />
                    )}
                </mask>
                <g mask="url(#mask0_3446_53608)">
                    <rect width="680" height="640" fill="#F2F3F8" />
                    <path
                        opacity="0.1"
                        d="M657.187 310.187C657.947 309.427 658.978 309 660.053 309H691.61C694.034 309 696 307.034 696 304.609V273.39C696 270.966 694.034 269 691.61 269H660.391C657.966 269 656 270.966 656 273.39V304.251C656 305.416 655.538 306.532 654.715 307.356L654.357 307.714C653.533 308.537 652.417 309 651.252 309H620.39C617.966 309 616 310.965 616 313.39V344.609C616 347.034 617.966 348.999 620.39 348.999H651.609C654.034 348.999 656 347.034 656 344.609V313.053C656 311.978 656.427 310.947 657.187 310.187Z"
                        fill="#A192EC"
                    />
                    <path
                        opacity="0.1"
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M141.367 72.7145C142.191 73.5378 143.307 74.0004 144.472 74.0004H175.61C178.034 74.0004 180 75.966 180 78.3907V109.61C180 112.035 178.034 114.001 175.61 114.001L144.055 114.001C142.98 114.001 141.949 114.428 141.189 115.188C140.429 115.948 140.002 116.979 140.002 118.054V149.611C140.002 152.035 138.036 154.001 135.611 154.001H104.392C101.967 154.001 100.001 152.035 100.001 149.611V118.472C100.001 117.308 99.5387 116.191 98.7154 115.368L98.6342 115.287C97.8109 114.463 96.6942 114.001 95.5299 114.001H64.3903C61.9656 114.001 60 112.035 60 109.61V78.3906C60 75.966 61.9656 74.0004 64.3903 74.0004H95.2531C96.4174 74.0004 97.5341 73.5378 98.3574 72.7145L98.7154 72.3565C99.5387 71.5332 100.001 70.4165 100.001 69.2521V38.3903C100.001 35.9656 101.967 34 104.392 34H135.611C138.036 34 140.002 35.9656 140.002 38.3903V69.5304C140.002 70.6947 140.464 71.8114 141.287 72.6348L141.367 72.7145ZM138.636 75.2862C137.812 74.4629 136.696 74.0003 135.531 74.0003H104.054C102.979 74.0003 101.948 74.4274 101.188 75.1876C100.427 75.9479 100 76.9789 100 78.0541V109.531C100 110.695 100.463 111.812 101.286 112.635L101.366 112.715C102.189 113.538 103.306 114.001 104.47 114.001L135.254 114.001C136.418 114.001 137.535 113.538 138.359 112.715L138.714 112.36C139.537 111.536 140 110.42 140 109.255V78.4688C140 77.3045 139.537 76.1878 138.714 75.3644L138.636 75.2862Z"
                        fill="#A192EC"
                    />
                    <g opacity="0.1">
                        <path
                            d="M560.2 131L636.832 131C637.672 131 638.478 130.666 639.072 130.072C639.666 129.478 640 128.672 640 127.832L640 107.2C640 104.88 641.88 103 644.2 103H663.8C666.12 103 668 104.88 668 107.2V126.8C668 129.12 666.12 131 663.8 131H643.169C642.329 131 641.522 131.334 640.928 131.928C640.334 132.522 640 133.329 640 134.169V154.8C640 157.12 638.12 159 635.8 159H560.2C557.88 159 556 157.12 556 154.8L556 135.2C556 132.88 557.88 131 560.2 131Z"
                            fill="#A192EC"
                        />
                        <path
                            d="M588.2 75C585.88 75 584 76.8804 584 79.2L584 98.8C584 101.12 585.88 103 588.2 103L635.8 103C638.12 103 640 101.12 640 98.8V78.169C640 77.3285 640.334 76.5225 640.928 75.9282C641.522 75.3339 642.329 75 643.169 75H663.8C666.12 75 668 73.1196 668 70.8V51.2C668 48.8804 666.12 47 663.8 47L644.2 47C641.88 47 640 48.8804 640 51.2V71.8317C640 72.672 639.666 73.4778 639.072 74.072C638.478 74.6662 637.672 75 636.832 75L588.2 75Z"
                            fill="#A192EC"
                        />
                    </g>
                    <path
                        opacity="0.1"
                        d="M246.187 613.187C246.947 612.427 247.978 612 249.053 612H280.61C283.034 612 285 610.034 285 607.609V576.39C285 573.966 283.034 572 280.61 572H249.391C246.966 572 245 573.966 245 576.39V607.251C245 608.416 244.538 609.532 243.715 610.356L243.357 610.714C242.533 611.537 241.417 612 240.252 612H209.39C206.966 612 205 613.965 205 616.39V647.609C205 650.034 206.966 651.999 209.39 651.999H240.609C243.034 651.999 245 650.034 245 647.609V616.053C245 614.978 245.427 613.947 246.187 613.187Z"
                        fill="#A192EC"
                    />
                    <path
                        opacity="0.1"
                        d="M608 534C611.314 534 614 536.686 614 540V568C614 571.314 611.314 574 608 574H580C576.686 574 574 571.314 574 568L574 540C574 536.686 576.686 534 580 534L608 534Z"
                        fill="#A192EC"
                    />
                    <path
                        opacity="0.1"
                        d="M24 430C27.3137 430 30 432.686 30 436V464C30 467.314 27.3137 470 24 470H-4C-7.31371 470 -10 467.314 -10 464L-10 436C-10 432.686 -7.31371 430 -4 430L24 430Z"
                        fill="#A192EC"
                    />
                    <path
                        opacity="0.1"
                        d="M244 422C247.314 422 250 424.686 250 428V456C250 459.314 247.314 462 244 462H216C212.686 462 210 459.314 210 456L210 428C210 424.686 212.686 422 216 422L244 422Z"
                        fill="#A192EC"
                    />
                    <g opacity="0.3">
                        <mask
                            id="mask1_3446_53608"
                            style={{ maskType: 'alpha' }}
                            maskUnits="userSpaceOnUse"
                            x="117"
                            y="83"
                            width="453"
                            height="454"
                        >
                            <path
                                d="M233.124 111.197C244.841 101.457 253.887 93.9427 264.679 89.3353C275.449 84.7369 287.999 83.0209 306.723 84.9876C325.467 86.9564 337.053 89.8484 348.025 93.1952C350.818 94.0469 353.573 94.9292 356.399 95.834C364.681 98.4856 373.567 101.33 385.738 104.163C397.319 106.859 408.358 108.308 418.825 109.682C424.571 110.436 430.144 111.167 435.54 112.07C450.802 114.624 464.75 118.554 477.568 128.213C501.825 146.494 522.968 169.946 539.201 198.063C555.434 226.18 565.173 256.216 568.876 286.364C570.513 299.69 567.386 311.412 563.079 323.06C561.857 326.365 560.538 329.67 559.206 333.004C555.856 341.393 552.431 349.972 550.293 359.228C548.193 368.317 547.034 377.973 545.874 387.64C545.232 392.986 544.59 398.335 543.789 403.594C541.53 418.408 538 432.582 529.683 444.328C525.35 450.447 518.867 455.168 511.05 459.075C503.233 462.981 494.115 466.058 484.543 468.909C480.561 470.094 476.498 471.241 472.42 472.392C456.935 476.763 441.224 481.197 428.819 488.082C413.409 496.635 403.42 505.868 394.76 513.872C392.205 516.234 389.766 518.488 387.338 520.587C382.002 525.198 376.717 529.061 370.351 531.708C363.988 534.353 356.518 535.794 346.804 535.52C325.721 534.925 309.554 528.407 294.165 519.02C286.466 514.323 278.963 508.909 271.132 503.154C270.131 502.418 269.123 501.677 268.11 500.93C261.204 495.844 254 490.539 246.164 485.278C238.996 480.465 230.587 475.543 221.733 470.375L221.115 470.014C212.44 464.952 203.353 459.648 194.567 453.962C176.573 442.317 159.916 429.113 150.721 413.195C146.458 404.391 141.626 396.306 137.009 388.579C136.7 388.062 136.393 387.548 136.086 387.035C131.186 378.827 126.594 371.006 123.224 363.089C119.856 355.177 117.717 347.187 117.716 338.65C117.715 330.116 119.85 321.005 125.075 310.853C146.151 269.897 150.546 220.836 153.588 186.12C155.088 168.997 168.984 155.163 185.603 143.122C193.067 137.715 201.046 132.692 208.645 127.909C209.491 127.377 210.333 126.847 211.168 126.32C219.496 121.068 227.242 116.086 233.124 111.197Z"
                                fill="#D9D9D9"
                                stroke="#A192EC"
                            />
                        </mask>
                        <g id="round-lines" ref={roundRef} mask="url(#mask1_3446_53608)">
                            <rect
                                ref={roundLinesRef}
                                x="271.539"
                                y="562.9"
                                width="385"
                                height="385"
                                rx="170"
                                transform="rotate(-120 271.539 562.9)"
                                stroke="#A192EC"
                                strokeWidth="0"
                                strokeDasharray="4 6"
                            />
                        </g>
                    </g>
                    <g opacity="0.5">
                        <ellipse
                            ref={ellipse1Ref}
                            opacity="0.5"
                            cx="339.503"
                            cy="300"
                            rx="71.5"
                            ry="141"
                            stroke="#A192EC"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeDasharray="8 8"
                        />
                        <ellipse
                            ref={ellipse2Ref}
                            opacity="0.5"
                            cx="339.5"
                            cy="300.001"
                            rx="71.5"
                            ry="141"
                            transform="rotate(60 339.5 300.001)"
                            stroke="#A192EC"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeDasharray="8 8"
                        />
                        <ellipse
                            ref={ellipse3Ref}
                            opacity="0.3"
                            cx="339.499"
                            cy="300"
                            rx="71.5"
                            ry="141"
                            transform="rotate(-60 339.499 300)"
                            stroke="#A192EC"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeDasharray="8 8"
                        />
                    </g>
                </g>
                <g ref={bgItem2} filter="url(#filter0_d_3446_53608)">
                    <rect x="48" y="488" width="88" height="88" rx="12" fill="white" />
                    <rect x="48.5" y="488.5" width="87" height="87" rx="11.5" stroke="#E5E7F1" />
                    <g filter="url(#filter1_b_3446_53608)">
                        <rect x="60" y="500" width="64" height="64" rx="4" fill="#8ABDF9" />
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M77.375 530.903C77.9375 523.338 84.2704 517.375 92 517.375C90.7815 517.375 89.6966 517.908 88.8041 518.722C87.916 519.533 87.1656 520.664 86.5586 522.001C85.9481 523.346 85.4738 524.92 85.1528 526.627C84.8955 527.996 84.7389 529.438 84.6867 530.903H77.375ZM77.375 533.097H84.6867C84.7389 534.562 84.8955 536.004 85.1528 537.373C85.4738 539.08 85.9481 540.654 86.5586 541.999C87.1656 543.336 87.916 544.467 88.8041 545.278C89.6966 546.092 90.7815 546.625 92 546.625C84.2704 546.625 77.9375 540.662 77.375 533.097Z"
                            fill="url(#paint0_linear_3446_53608)"
                        />
                        <path
                            d="M92 519.416C91.5967 519.416 91.0757 519.587 90.4698 520.14C89.8595 520.697 89.2484 521.57 88.7086 522.759C88.1724 523.94 87.7369 525.367 87.4373 526.961C87.2013 528.216 87.0549 529.546 87.0035 530.903H96.9965C96.9451 529.546 96.7987 528.216 96.5627 526.961C96.2631 525.367 95.8276 523.94 95.2914 522.759C94.7516 521.57 94.1405 520.697 93.5302 520.14C92.9243 519.587 92.4033 519.416 92 519.416Z"
                            fill="url(#paint1_linear_3446_53608)"
                        />
                        <path
                            d="M87.4373 537.039C87.7369 538.633 88.1724 540.06 88.7086 541.241C89.2484 542.43 89.8595 543.303 90.4698 543.86C91.0757 544.413 91.5967 544.584 92 544.584C92.4033 544.584 92.9243 544.413 93.5302 543.86C94.1405 543.303 94.7516 542.43 95.2914 541.241C95.8276 540.06 96.2631 538.633 96.5627 537.039C96.7987 535.784 96.9451 534.454 96.9965 533.097H87.0035C87.0549 534.454 87.2013 535.784 87.4373 537.039Z"
                            fill="url(#paint2_linear_3446_53608)"
                        />
                        <path
                            d="M92 517.375C93.2185 517.375 94.3034 517.908 95.1959 518.722C96.084 519.533 96.8344 520.664 97.4414 522.001C98.0519 523.346 98.5262 524.92 98.8472 526.627C99.1045 527.996 99.2611 529.438 99.3133 530.903H106.625C106.063 523.338 99.7296 517.375 92 517.375Z"
                            fill="url(#paint3_linear_3446_53608)"
                        />
                        <path
                            d="M98.8472 537.373C98.5262 539.08 98.0519 540.654 97.4414 541.999C96.8344 543.336 96.084 544.467 95.1959 545.278C94.3034 546.092 93.2185 546.625 92 546.625C99.7296 546.625 106.063 540.662 106.625 533.097H99.3133C99.2611 534.562 99.1045 536.004 98.8472 537.373Z"
                            fill="url(#paint4_linear_3446_53608)"
                        />
                    </g>
                </g>
                <text
                    ref={speedRef}
                    x="50%"
                    y="45%"
                    textAnchor="middle"
                    alignmentBaseline="middle"
                    fill="#0D1126"
                    fontSize="72px"
                    dominantBaseline="middle"
                >
                    0
                </text>
                <path
                    d="M305.112 341.448C303.512 341.448 302.083 341.107 300.824 340.424C299.565 339.72 298.573 338.696 297.848 337.352C297.123 336.008 296.76 334.365 296.76 332.424V327.176C296.76 324.253 297.56 322.024 299.16 320.488C300.76 318.931 302.925 318.152 305.656 318.152C308.344 318.152 310.413 318.888 311.864 320.36C313.315 321.811 314.04 323.763 314.04 326.216V326.376H310.616V326.12C310.616 325.203 310.435 324.381 310.072 323.656C309.709 322.909 309.165 322.323 308.44 321.896C307.715 321.469 306.787 321.256 305.656 321.256C303.949 321.256 302.616 321.779 301.656 322.824C300.696 323.848 300.216 325.277 300.216 327.112V332.488C300.216 334.301 300.696 335.741 301.656 336.808C302.616 337.853 303.96 338.376 305.688 338.376C307.395 338.376 308.643 337.907 309.432 336.968C310.221 336.029 310.616 334.813 310.616 333.32V332.904H304.6V329.928H314.04V341H310.84V338.728H310.328C310.136 339.133 309.848 339.549 309.464 339.976C309.101 340.403 308.568 340.755 307.864 341.032C307.181 341.309 306.264 341.448 305.112 341.448ZM327.708 341.448C326.172 341.448 324.988 341.171 324.156 340.616C323.346 340.061 322.738 339.443 322.332 338.76H321.82V341H318.588V318.6H321.884V327.368H322.396C322.652 326.941 322.994 326.536 323.42 326.152C323.847 325.747 324.412 325.416 325.116 325.16C325.82 324.904 326.684 324.776 327.708 324.776C329.031 324.776 330.247 325.096 331.356 325.736C332.466 326.376 333.351 327.304 334.012 328.52C334.674 329.736 335.004 331.187 335.004 332.872V333.352C335.004 335.059 334.663 336.52 333.98 337.736C333.319 338.931 332.434 339.848 331.324 340.488C330.236 341.128 329.031 341.448 327.708 341.448ZM326.748 338.568C328.178 338.568 329.351 338.109 330.268 337.192C331.207 336.275 331.676 334.963 331.676 333.256V332.968C331.676 331.283 331.218 329.981 330.3 329.064C329.383 328.147 328.199 327.688 326.748 327.688C325.34 327.688 324.167 328.147 323.228 329.064C322.311 329.981 321.852 331.283 321.852 332.968V333.256C321.852 334.963 322.311 336.275 323.228 337.192C324.167 338.109 325.34 338.568 326.748 338.568ZM339.088 347.4V325.224H342.32V327.496H342.832C343.238 326.792 343.846 326.163 344.656 325.608C345.488 325.053 346.672 324.776 348.208 324.776C349.531 324.776 350.736 325.096 351.824 325.736C352.934 326.376 353.819 327.304 354.48 328.52C355.163 329.715 355.504 331.165 355.504 332.872V333.352C355.504 335.059 355.174 336.52 354.512 337.736C353.851 338.931 352.966 339.848 351.856 340.488C350.747 341.128 349.531 341.448 348.208 341.448C347.184 341.448 346.32 341.32 345.616 341.064C344.912 340.808 344.347 340.488 343.92 340.104C343.494 339.699 343.152 339.283 342.896 338.856H342.384V347.4H339.088ZM347.248 338.568C348.699 338.568 349.883 338.109 350.8 337.192C351.718 336.275 352.176 334.963 352.176 333.256V332.968C352.176 331.283 351.707 329.981 350.768 329.064C349.851 328.147 348.678 327.688 347.248 327.688C345.84 327.688 344.667 328.147 343.728 329.064C342.811 329.981 342.352 331.283 342.352 332.968V333.256C342.352 334.963 342.811 336.275 343.728 337.192C344.667 338.109 345.84 338.568 347.248 338.568ZM356.4 347.4L365.808 318.6H369.104L359.696 347.4H356.4ZM377.459 341.448C375.453 341.448 373.789 341 372.467 340.104C371.144 339.208 370.333 337.853 370.035 336.04L373.107 335.304C373.277 336.179 373.565 336.872 373.971 337.384C374.376 337.896 374.877 338.259 375.475 338.472C376.093 338.685 376.755 338.792 377.459 338.792C378.504 338.792 379.304 338.589 379.859 338.184C380.435 337.779 380.723 337.256 380.723 336.616C380.723 335.976 380.456 335.507 379.923 335.208C379.389 334.909 378.6 334.664 377.555 334.472L376.467 334.28C375.4 334.088 374.429 333.811 373.555 333.448C372.68 333.085 371.987 332.584 371.475 331.944C370.963 331.304 370.707 330.483 370.707 329.48C370.707 327.987 371.261 326.835 372.371 326.024C373.48 325.192 374.952 324.776 376.786 324.776C378.557 324.776 380.008 325.181 381.139 325.992C382.291 326.781 383.037 327.859 383.379 329.224L380.307 330.088C380.115 329.128 379.709 328.456 379.091 328.072C378.472 327.667 377.704 327.464 376.786 327.464C375.891 327.464 375.187 327.635 374.675 327.976C374.163 328.296 373.907 328.755 373.907 329.352C373.907 329.992 374.152 330.461 374.643 330.76C375.155 331.059 375.837 331.283 376.691 331.432L377.811 331.624C378.941 331.816 379.976 332.083 380.915 332.424C381.853 332.765 382.589 333.256 383.123 333.896C383.677 334.536 383.955 335.389 383.955 336.456C383.955 338.035 383.368 339.261 382.195 340.136C381.021 341.011 379.443 341.448 377.459 341.448Z"
                    fill="#0D1126"
                />
                <g ref={bgItem1} filter="url(#filter2_d_3446_53608)">
                    <rect x="512" y="32" width="88" height="88" rx="12" fill="white" />
                    <rect x="512.5" y="32.5" width="87" height="87" rx="11.5" stroke="#E5E7F1" />
                    <g filter="url(#filter3_b_3446_53608)">
                        <rect x="524" y="44" width="64" height="64" rx="4" fill="#A192EC" />
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M544.144 66.6613C543.625 67.3874 543.625 69.5457 543.625 73.8625V75.9883C543.625 83.5997 549.454 87.2934 553.111 88.8618C554.103 89.2873 554.599 89.5 556 89.5C557.401 89.5 557.897 89.2873 558.889 88.8618C562.546 87.2934 568.375 83.5997 568.375 75.9883V73.8625C568.375 69.5457 568.375 67.3874 567.856 66.6613C567.337 65.9351 565.27 65.2404 561.136 63.8511L560.348 63.5864C558.193 62.8621 557.116 62.5 556 62.5C554.884 62.5 553.807 62.8621 551.652 63.5864L550.864 63.8511C546.73 65.2404 544.663 65.9351 544.144 66.6613ZM560.207 73.9743C560.586 73.5572 560.549 72.9172 560.124 72.5447C559.699 72.1723 559.048 72.2085 558.668 72.6257L554.527 77.1798L553.332 75.8657C552.952 75.4485 552.301 75.4123 551.876 75.7847C551.451 76.1572 551.414 76.7972 551.793 77.2143L553.758 79.3743C553.953 79.5895 554.233 79.7125 554.527 79.7125C554.821 79.7125 555.1 79.5895 555.296 79.3743L560.207 73.9743Z"
                            fill="url(#paint5_linear_3446_53608)"
                        />
                    </g>
                </g>
                <g ref={bgItem3} filter="url(#filter4_d_3446_53608)">
                    <rect x="560" y="408" width="88" height="88" rx="12" fill="white" />
                    <rect x="560.5" y="408.5" width="87" height="87" rx="11.5" stroke="#E5E7F1" />
                    <g filter="url(#filter5_b_3446_53608)">
                        <rect x="572" y="420" width="64" height="64" rx="4" fill="#D993F7" />
                        <path
                            d="M594.507 448.872L599.1 442.657C602.069 438.64 603.554 436.631 604.939 437.056C606.324 437.48 606.324 439.944 606.324 444.871V445.335C606.324 447.112 606.324 448.001 606.892 448.558L606.922 448.587C607.502 449.133 608.427 449.133 610.276 449.133C613.605 449.133 615.269 449.133 615.831 450.142C615.841 450.159 615.85 450.176 615.858 450.192C616.389 451.218 615.426 452.521 613.499 455.129L608.905 461.343C605.936 465.36 604.452 467.369 603.067 466.944C601.682 466.52 601.682 464.056 601.682 459.129L601.682 458.665C601.682 456.888 601.682 455.999 601.114 455.442L601.084 455.413C600.504 454.868 599.579 454.868 597.73 454.868C594.401 454.868 592.737 454.868 592.175 453.858C592.165 453.841 592.156 453.825 592.148 453.808C591.617 452.783 592.58 451.479 594.507 448.872Z"
                            fill="url(#paint6_linear_3446_53608)"
                        />
                    </g>
                </g>
                <path
                    d="M537 300C537 408.8 448.8 497 340 497C231.2 497 143 408.8 143 300C143 191.2 231.2 103 340 103C448.8 103 537 191.2 537 300ZM172.55 300C172.55 392.48 247.52 467.45 340 467.45C432.48 467.45 507.45 392.48 507.45 300C507.45 207.52 432.48 132.55 340 132.55C247.52 132.55 172.55 207.52 172.55 300Z"
                    fill="#A192EC"
                />
                <path
                    d="M525 300C525 402.173 442.173 485 340 485C237.827 485 155 402.173 155 300C155 197.827 237.827 115 340 115C442.173 115 525 197.827 525 300ZM182.75 300C182.75 386.847 253.153 457.25 340 457.25C426.847 457.25 497.25 386.847 497.25 300C497.25 213.153 426.847 142.75 340 142.75C253.153 142.75 182.75 213.153 182.75 300Z"
                    fill="url(#paint7_linear_3446_53608)"
                />
                <path
                    ref={loaderRef}
                    d="M509.553 320.639C512.95 321.053 516.05 318.635 516.344 315.226C519.34 280.532 512.036 245.672 495.278 215.042C477.526 182.598 450.058 156.529 416.731 140.496C383.404 124.464 345.892 119.274 309.463 125.654C273.035 132.035 239.52 149.665 213.626 176.07C187.731 202.476 170.759 236.328 165.091 272.875C159.423 309.421 165.345 346.824 182.026 379.832C198.706 412.84 225.307 439.793 258.091 456.908C289.043 473.065 324.039 479.686 358.668 476.013C362.07 475.652 364.427 472.506 363.947 469.118C363.468 465.73 360.333 463.385 356.93 463.737C324.866 467.053 292.482 460.883 263.825 445.924C233.335 430.008 208.597 404.941 193.084 374.244C177.571 343.546 172.064 308.761 177.334 274.773C182.605 240.785 198.39 209.302 222.472 184.746C246.554 160.189 277.722 143.792 311.601 137.858C345.479 131.924 380.365 136.752 411.36 151.662C442.354 166.572 467.899 190.816 484.408 220.989C499.924 249.348 506.725 281.605 504.037 313.728C503.751 317.138 506.157 320.226 509.553 320.639Z"
                    fill="url(#paint8_angular_3446_53608)"
                />
            </g>
            <defs>
                <filter
                    id="filter0_d_3446_53608"
                    x="36"
                    y="488"
                    width="112"
                    height="112"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feMorphology
                        radius="12"
                        operator="erode"
                        in="SourceAlpha"
                        result="effect1_dropShadow_3446_53608"
                    />
                    <feOffset dy="12" />
                    <feGaussianBlur stdDeviation="12" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.231373 0 0 0 0 0.172549 0 0 0 0 0.694118 0 0 0 0.2 0"
                    />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3446_53608" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3446_53608" result="shape" />
                </filter>
                <filter
                    id="filter1_b_3446_53608"
                    x="36"
                    y="476"
                    width="112"
                    height="112"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="12" />
                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_3446_53608" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_3446_53608" result="shape" />
                </filter>
                <filter
                    id="filter2_d_3446_53608"
                    x="500"
                    y="32"
                    width="112"
                    height="112"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feMorphology
                        radius="12"
                        operator="erode"
                        in="SourceAlpha"
                        result="effect1_dropShadow_3446_53608"
                    />
                    <feOffset dy="12" />
                    <feGaussianBlur stdDeviation="12" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.231373 0 0 0 0 0.172549 0 0 0 0 0.694118 0 0 0 0.2 0"
                    />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3446_53608" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3446_53608" result="shape" />
                </filter>
                <filter
                    id="filter3_b_3446_53608"
                    x="500"
                    y="20"
                    width="112"
                    height="112"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="12" />
                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_3446_53608" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_3446_53608" result="shape" />
                </filter>
                <filter
                    id="filter4_d_3446_53608"
                    x="548"
                    y="408"
                    width="112"
                    height="112"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feMorphology
                        radius="12"
                        operator="erode"
                        in="SourceAlpha"
                        result="effect1_dropShadow_3446_53608"
                    />
                    <feOffset dy="12" />
                    <feGaussianBlur stdDeviation="12" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.231373 0 0 0 0 0.172549 0 0 0 0 0.694118 0 0 0 0.2 0"
                    />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3446_53608" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3446_53608" result="shape" />
                </filter>
                <filter
                    id="filter5_b_3446_53608"
                    x="548"
                    y="396"
                    width="112"
                    height="112"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="12" />
                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_3446_53608" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_3446_53608" result="shape" />
                </filter>
                <linearGradient
                    id="paint0_linear_3446_53608"
                    x1="92"
                    y1="517.375"
                    x2="92"
                    y2="546.625"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="white" stopOpacity="0.3" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_3446_53608"
                    x1="92"
                    y1="517.375"
                    x2="92"
                    y2="546.625"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="white" stopOpacity="0.3" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_3446_53608"
                    x1="92"
                    y1="517.375"
                    x2="92"
                    y2="546.625"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="white" stopOpacity="0.3" />
                </linearGradient>
                <linearGradient
                    id="paint3_linear_3446_53608"
                    x1="92"
                    y1="517.375"
                    x2="92"
                    y2="546.625"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="white" stopOpacity="0.3" />
                </linearGradient>
                <linearGradient
                    id="paint4_linear_3446_53608"
                    x1="92"
                    y1="517.375"
                    x2="92"
                    y2="546.625"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="white" stopOpacity="0.3" />
                </linearGradient>
                <linearGradient
                    id="paint5_linear_3446_53608"
                    x1="556"
                    y1="62.5"
                    x2="556"
                    y2="89.5"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="white" stopOpacity="0.3" />
                </linearGradient>
                <linearGradient
                    id="paint6_linear_3446_53608"
                    x1="604.003"
                    y1="437"
                    x2="604.003"
                    y2="467"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="white" stopOpacity="0.3" />
                </linearGradient>
                <linearGradient
                    id="paint7_linear_3446_53608"
                    x1="371.511"
                    y1="-84.2307"
                    x2="-21.6982"
                    y2="304.218"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#A192EC" />
                    <stop offset="1" stopColor="#5547EB" />
                </linearGradient>
                <radialGradient
                    id="paint8_angular_3446_53608"
                    cx="45%"
                    cy="85%"
                    r="90%"
                    gradientUnits="objectBoundingBox"
                >
                    <stop offset="0%" stopColor="white" stopOpacity="0" />
                    <stop offset="34.6%" stopColor="white" stopOpacity="0.38" />
                    <stop offset="73.7%" stopColor="white" />
                </radialGradient>

                <clipPath id="clip0_3446_53608">
                    <rect width="680" height="640" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default NetworkIllustration;
